module.exports = __webpack_public_path__ + "static/hold-cleaner-5755c72a5006e6a2c67104315a91cc9a.mp4";